import React from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  toggleCleanupScheduleCount,
  toggleCleanupMonths,
  toggleCleanupMonthsCheck
} from "store/actions";
import { forbidExtraProps, outlineFocus } from "utils";
import { CONTENT, TOOLTIPS } from "consts";
import Tooltip from "App/common/ui/Tooltip";

function cleanup(props) {
  return (
    <div className="advance_cleanup">
      <div className="sub_title">
        <p>
          Cleanup
          <Tooltip {...TOOLTIPS.backupSettings.advanced.cleanup}>
            <span className="icon" />
          </Tooltip>
        </p>
      </div>
      <div className="cleanup_item">
        <div className="checkbox_wrapper just_flex">
          <div className="just_flex">
            <p>{CONTENT.backupSettings.advance.cleanup.automatically.part1}</p>
            <div className="custom_number" style={{ margin: "0 10px" }}>
              <input
                type="number"
                className="input_number"
                value={props.cleanup.scheduleCount}
                onChange={e => props.toggleCleanupScheduleCount(e.target.value)}
              />
            </div>
            <p>{CONTENT.backupSettings.advance.cleanup.automatically.part2}</p>
          </div>
        </div>
      </div>
      <div className="cleanup_item last_child_bottom">
        <div className="checkbox_wrapper just_flex">
          <div
            className="check"
            onChange={() => props.toggleCleanupMonthsCheck()}
          >
            <input
              type="checkbox"
              className={
                "input_checkbox" +
                (props.cleanup.months.checked && window.browserName === "ie"
                  ? " ie_checked"
                  : "")
              }
              id="delete_versions_1"
              defaultChecked={props.cleanup.months.checked}
              onFocus={() => {
                outlineFocus("delete_versions_1_label", 1);
              }}
              onBlur={() => {
                outlineFocus("delete_versions_1_label", 0);
              }}
            />
            <label htmlFor="delete_versions_1" id="delete_versions_1_label" />
          </div>
          <div className="just_flex checkbox_p ">
            <p
              onClick={e => {
                props.toggleCleanupMonthsCheck();
              }}
            >
              {CONTENT.backupSettings.advance.cleanup.delete.part1}
            </p>
            <div
              className={[
                "custom_number transparent_layer_wrap transparent_layer_dv",
                props.cleanup.months.checked ? "layer_active" : ""
              ].join(" ")}
              style={{ margin: "0 10px" }}
            >
              {!props.cleanup.months.checked && (
                <div
                  className="transparent_layer"
                  onClick={e => {
                    props.toggleCleanupMonthsCheck();
                  }}
                />
              )}
              <input
                type="number"
                className="input_number"
                value={props.cleanup.months.value}
                onChange={e => {
                  props.toggleCleanupMonths(e.target.value);
                }}
              />
            </div>
            <p
              onClick={e => {
                props.toggleCleanupMonthsCheck();
              }}
            >
              {CONTENT.backupSettings.advance.cleanup.delete.part2}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

cleanup.propTypes = forbidExtraProps(
  {
    cleanup: PropTypes.object.isRequired
  },
  [
    "toggleCleanupScheduleCount",
    "toggleCleanupMonths",
    "toggleCleanupMonthsCheck"
  ]
);

function mapStateToProps(state) {
  return {
    cleanup: state.backupSettings.cleanup
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleCleanupScheduleCount,
      toggleCleanupMonths,
      toggleCleanupMonthsCheck
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(cleanup);
